import { styled } from "@mui/material"
import { Stack } from "src/shared/components"

const BorderStack = styled(Stack)(({ theme }) => ({
  gap: "8px",
  borderRadius: "8px",
  padding: "16px",
  border: `1px solid ${theme.palette.divider}`
}))

export default BorderStack
